import * as React from "react";
function CVMSquaredIcon(props: React.SVGProps<any>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={18} height={18} {...props}>
      <defs>
        <path id="a07265e51-c16c-48cf-a10d-ab71ce8d1c18" d="M4.995 4.693 0 0v2.343l4.995 4.7 4.995-4.7V0z" />
        <path id="c65a3f490-8e2a-4b50-b622-aba198e9f0b3" d="M4.995 4.693 0 0v2.343l4.995 4.7 4.995-4.7V0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#187452" fillRule="nonzero" d="M0 0h18v18H0z" />
        <g fillRule="nonzero">
          <path fill="#8FB195" d="M8.995 3v2.353l2.491 2.34h2.504z" />
          <path
            fill="#43946A"
            d="M8.989 12.383 4 7.693 8.99 3.006V5.36L6.49 7.693l2.498 2.338v2.352Zm.006-9.37V5.34l2.491 2.353h2.49l-4.98 4.693-.007-.003v-2.352l.006.006 2.491-2.344-2.49-2.34-.007.006V3.006L8.995 3v.012Z"
          />
        </g>
        <g transform="translate(4 7.693)">
          <mask id="bffbab4bc" fill="#fff">
            <use xlinkHref="#a07265e51-c16c-48cf-a10d-ab71ce8d1c18" />
          </mask>
          {/* <path fill="#FBC71A" fillRule="nonzero" d="M-3.303-3.104h16.597v13.25H-3.303z" mask="url(#bffbab4bc)" /> */}
        </g>
        <g transform="translate(4 7.693)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c65a3f490-8e2a-4b50-b622-aba198e9f0b3" />
          </mask>
          <path
            fill="#FBC707"
            fillRule="nonzero"
            d="M4.989 4.69 0 0 4.99-4.687v2.353L2.49 0 4.99 2.337V4.69Zm.006-9.37v2.327L7.486 0h2.491L4.995 4.693 4.99 4.69V2.337l.006.007L7.486 0l-2.49-2.34-.007.006v-2.353l.006-.006v.012Z"
            mask="url(#d)"
          />
        </g>
        <path fill="#8FB195" fillRule="nonzero" d="M8.998 14.742 14 10.037V15H4v-4.963z" />
        <path fill="#187452" fillRule="nonzero" d="m8.995 5.353-2.504 2.34 2.504 2.353 2.491-2.353z" />
      </g>
    </svg>
  );
}
export default CVMSquaredIcon;
